module.exports = __webpack_public_path__ + "media/05 the Tomb-Sweeping Day.19796e27.mp3";